import PageHeader from "../../components/Header/PageHeader";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import "./style.css";
import React, { useEffect, useState } from "react";
import { fetchWrapper } from "../../helpers";
import {
    Layout, Row, Col, Card, Space, Typography, Button, Divider, Select, Modal,
    Tag, Avatar, Descriptions, Input, Alert, message, Form
} from "antd";
import {
    ArrowLeftOutlined, GlobalOutlined, SettingOutlined, CrownOutlined,
    LinkedinOutlined, FacebookOutlined, InstagramOutlined, EnvironmentOutlined
} from "@ant-design/icons";

import { useDebounce } from "use-debounce";
import i18n from "i18next";
import { getProvidersUrls } from "../../utils/auth";
import { PROVIDER } from "../../constants/auth";
import { authActions } from "../../store";
import { useDispatch } from "react-redux";
import moment from "moment";
import InviteFriend from "../../components/Forms/InviteFriend";
import ReferralsModal from "../../components/modals/Referrals-modal";
import axios from "axios";
import { getUserTimeInfo } from "../../helpers/get-user-time-zone";
import TimeZoneModal from "../../components/modals/TimeZone-modal";
import RemoveAccountModal from "../../components/modals/Remove-account-modal";
import { useOrganization } from "../../context/organizationContext";
import OrganizationSettings from "../../components/blocks/OrganizationSettings";
import OrganizationLogo from "../../components/blocks/OrganizationLogo";
import { getUserCoordinates } from "../../utils/getUserCoordinates";
import { ImeanHeader } from "../../components/Header/Header";
import { normalizeLang } from "../../utils/LangUtils/langStorage";
import { StickyNavigationHeader } from "../../components/Navigation/StickyNavigationHeader";
import threadsIcon from "../icons/threads-icon.svg"
import { useConfirm } from "../../hooks/useConfirm";
import { useNotificationContext } from '../../components/NotifWrapper/NotifWrapper';
import { NotificationTester } from '../../components/NotificationTester'

const baseUrl = `${process.env.REACT_APP_API_URL}`;

export const ProfilePage = () => {
    // const prms = new URLSearchParams(window.location.search);
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();
    const [handleUpdateProfile, sethandleUpdateProfile] = useState(false);
    const navigate = useNavigate();
    const user = useSelector((obj) => obj.auth.user);
    const org = useOrganization();
    const [profile, setProfile] = useState(null);
    const [currentTimeZone, setCurrentTimeZone] = useState(getUserTimeInfo());
    const [linkedInModalVisible, setLinkedInModalVisible] = useState(false);
    const [fbModalVisible, setFBModalVisible] = useState(false);
    const [fbModalInfoVisible, setFBModalInfoVisible] = useState(searchParams.get("helpFbModal") === "true" ? true : false);
    const [instModalInfoVisible, setInstModalInfoVisible] = useState(false);
    const [timeZones, setTimeZones] = useState([]);
    const [genLang, setGenLang] = useState();
    const [gender, setGender] = useState();
    const [name, setName] = useState(user.name);
    const [position, setPosition] = useState("");
    const [industry, setIndustry] = useState("");
    const [subDateEnd, setSubDateEnd] = useState();
    const [subLevel, setSubLevel] = useState();
    const [updateName] = useDebounce(name, 1000);
    const [updatePosition] = useDebounce(position, 1000);
    const [updateIndustry] = useDebounce(industry, 1000);
    const [handleUpdateReferrals, sethandleUpdateReferrals] = useState(false);
    const [fbPages, setFbPages] = useState([]);
    const [linkedInPages, setLinkedInPages] = useState([]);
    const [socialMediaUsers, setSocialMediaUsers] = useState({
        facebook: {},
        instagram: {},
        linkedIn: {},
        threads: {},
    });
    const [tokensIds, setTokensIds] = useState({
        facebook: "",
        instagram: "",
        linkedIn: "",
        threads: "",
    });
    const [tokens, setTokens] = useState({
        facebook: false,
        instagram: false,
        linkedIn: false,
        threads: false,
    });
    const [sid, setSid] = useState(jwtDecode(JSON.parse(localStorage.getItem("user")).accessToken).subscriptionLevel.id);
    const dispatch = useDispatch();

    const {
        isSupported,
        permission,
        requestPermission,
        showSuccess,
        showError,
        showInfo,
        canShow
    } = useNotificationContext();

    const go = async (sn) => {

        localStorage.setItem('provider', sn);
        const popup = window.open('', 'oauthWin', 'width=520,height=720'); // без noopener!
        if (!popup) {

            window.open(`${baseUrl}/auth/redirect-oauth?sn=${sn}`, '_blank');
            return;
        }

        try {


            popup.document.title = 'Connecting…';
            popup.document.body.innerHTML = `<p style="font:14px system-ui;margin:16px">Connecting to ${sn}…</p>`;


            const resp = await fetch(
                `${baseUrl}/auth/redirect-oauth?sn=${sn}&mode=url&ts=${Date.now()}`,
                { cache: 'no-store', credentials: 'include' }
            );
            if (!resp.ok) throw new Error(`Bad status ${resp.status}`);
            const { url } = await resp.json();

            popup.location.assign(url); // или: popup.location.href = url;
        } catch (e) {
            try { popup.close(); } catch { }
            window.open(`${baseUrl}/auth/redirect-oauth?sn=${sn}`, '_blank');
        }
    };


    const socialLogin = {
        instagram: () => go('instagram'),
        facebook: () => go('facebook'),
        linkedIn: () => go('linkedin'),
        threads: () => go('threads'),
    };

    const confirm = useConfirm();

    const socialUnhook = {
        linkedIn: async () => {
            const isUserAgree = await confirm({
                title: t("profile.unlinkLinkedinConfrimTitle") || "Подтверждение",
                message: t("profile.unlinkLinkedinConfrim") || "Вы уверены, что хотите отвязать LinkedIn?",
                confirmText: t("common.yes") || "Да",
                cancelText: t("common.no") || "Нет",
            });

            if (!isUserAgree) return;

            const res = await fetchWrapper.get(`${baseUrl}/unhook/linkedin/${tokensIds.linkedIn}`);
            if (res) {
                setTokens((prev) => ({ ...prev, linkedIn: false }));
                refreshToken();
            }
        },

        facebook: async () => {
            const isUserAgree = await confirm({
                title: t("profile.unlinkFacebookConfrimTitle") || "Подтверждение",
                message: t("profile.unlinkFacebookConfrim") || "Вы уверены, что хотите отвязать Facebook?",
                confirmText: t("common.yes") || "Да",
                cancelText: t("common.no") || "Нет",
            });

            if (!isUserAgree) return;

            const res = await fetchWrapper.get(`${baseUrl}/unhook/facebook/${tokensIds.facebook}`);
            if (res) {
                setTokens((prev) => ({ ...prev, facebook: false }));
                refreshToken();
            }
        },

        instagram: async () => {
            const isUserAgree = await confirm({
                title: t("profile.unlinkInstagramConfrimTitle") || "Подтверждение",
                message: t("profile.unlinkInstagramConfrim") || "Вы уверены, что хотите отвязать Instagram?",
                confirmText: t("common.yes") || "Да",
                cancelText: t("common.no") || "Нет",
            });

            if (!isUserAgree) return;

            const res = await fetchWrapper.get(`${baseUrl}/unhook/instagram/${tokensIds.instagram}`);
            if (res) {
                setTokens((prev) => ({ ...prev, instagram: false }));
                refreshToken();
            }
        },
        threads: async () => {
            const isUserAgree = await confirm({
                title: t("profile.unlinkThreadsConfirmTitle") || "Подтверждение",
                message: t("profile.unlinkThreadsConfirm") || "Вы уверены, что хотите отвязать Threads?",
                confirmText: t("common.yes") || "Да",
                cancelText: t("common.no") || "Нет",
            });
            if (!isUserAgree) return;

            const res = await fetchWrapper.get(`${baseUrl}/unhook/threads/${tokensIds.threads}`);
            if (res) {
                setTokens((prev) => ({ ...prev, threads: false }));
                refreshToken();
            }
        },
    };


    useEffect(() => {
        fetchWrapper
            .get(`${baseUrl}/auth/getSocialMediaTokens/`)
            .then((res) => {
                const socialUsers = {
                    facebook: null,
                    instagram: null,
                    linkedIn: null,
                    threads: null,
                };
                const newTokensId = {
                    facebook: "",
                    instagram: "",
                    linkedIn: "",
                    threads: "",
                };
                const filteredToken = {
                    facebook: false,
                    instagram: false,
                    linkedIn: false,
                    threads: false,
                };
                res.forEach((token) => {
                    if (token.socialMediaType === "FACEBOOK") {
                        filteredToken.facebook = true;
                        newTokensId.facebook = token.id;
                        socialUsers.facebook = { username: token?.username, email: token?.email };
                    }
                    if (token.socialMediaType === "INSTAGRAM") {
                        filteredToken.instagram = true;
                        newTokensId.instagram = token.id;
                        socialUsers.instagram = { username: token?.username, email: token?.email };
                    }
                    if (token.socialMediaType === "LINKEDIN") {
                        // console.log(token)
                        filteredToken.linkedIn = true;
                        newTokensId.linkedIn = token.id;
                        socialUsers.linkedIn = { username: token?.username, email: token?.email };
                    }
                    if (token.socialMediaType === "THREADS") {
                        filteredToken.threads = true;
                        newTokensId.threads = token.id;
                        socialUsers.threads = { username: token?.username, email: token?.email };
                    }
                });
                setSocialMediaUsers(socialUsers);
                setTokens(filteredToken);
                setTokensIds(newTokensId);
            })
            .catch(() => { });
    }, []);
    const refreshToken = () => {
        fetchWrapper.get(`${baseUrl}/auth/refresh-token`).then((res) => {
            const saved = localStorage.getItem("user");
            if (!saved) return;
            const oldUser = JSON.parse(localStorage.getItem("user"));
            oldUser.languageGeneration = genLang;
            oldUser.name = name;
            oldUser.accessToken = res.accessToken;
            localStorage.setItem("user", JSON.stringify(oldUser));
            setSubDateEnd(jwtDecode(res?.accessToken)?.userSubscription?.endDate);
            setSubLevel(jwtDecode(res?.accessToken)?.subscriptionLevel);
            dispatch(authActions.updateUser());
        });
    };

    useEffect(() => {
        const onMessage = (event) => {
            const data = event.data;
            if (!data || typeof data !== 'object') return;

            if (data.type === 'oauth_error') {
                message.error(t("profile.authError", { provider: data.sn, error: data.error }));
                return;
            }

            if (data.type === 'oauth_code') {
                const provider = String(data.sn || '').toLowerCase();

                dispatch(authActions.oauth({
                    provider,
                    code: data.code,
                    redirectUrl: data.redirectUrl,
                }))
                    .unwrap()
                    .then(() => {
                        message.success(t("profile.successOauth", { provider }));
                        setTimeout(() => window.location.reload(), 500);
                    })
                    .catch(() => {
                        message.error(t("profile.authFailed", { provider }));
                    });
            }
        };

        window.addEventListener('message', onMessage);
        return () => window.removeEventListener('message', onMessage);
    }, [dispatch]);

    const onChangeLanguage = (value) => {
        const ln = normalizeLang(value);
        setGenLang(ln);
    };

    const handleChangeGender = (gender) => {
        fetchWrapper
            .post(`${baseUrl}/profile/update-info`, {
                gender: gender,
            })
            .then((res) => {
                if (res) {
                    setGender(gender);
                }
            });
    };

    const onChangeTimeZone = (TZ) => {
        setCurrentTimeZone(TZ);
        fetchWrapper.post(`${baseUrl}/profile/update-info`, {
            timeZone: TZ,
        });
    };

    const showLinkedInModal = () => {
        setLinkedInModalVisible(true);
    };

    const showFBModal = () => {
        setFBModalVisible(true);
    };

    const showFBModalInfo = () => {
        setFBModalInfoVisible(true);
    };

    const showInstModalInfo = () => {
        setInstModalInfoVisible(true);
    };

    const handleChangeFBPage = (page) => {
        setFBModalVisible(false);
        fetchWrapper
            .post(`${baseUrl}/profile/update-info`, {
                facebookPageId: page.id,
            })
            .then((res) => {
                if (res) {
                    sethandleUpdateProfile((p) => !p);
                }
            });
    };

    const handleChangeLinkedInPage = (page) => {
        setLinkedInModalVisible(false);
        fetchWrapper
            .post(`${baseUrl}/profile/update-info`, {
                linkedinPageId: page.page_id,
            })
            .then((res) => {
                if (res) {
                    sethandleUpdateProfile((p) => !p);
                }
            });
    };

    const shareGeoData = async () => {
        let coordinates = null;
        try {
            coordinates = await getUserCoordinates();
        } catch (e) {
            console.error(e);
            message.error(t("profile.sharedGeoDataError"));
        }
        fetchWrapper
            .post(`${baseUrl}/profile/update-info`, {
                coordinates,
            })
            .then((res) => {
                if (res) {
                    message.success(t("profile.sharedGeoDataSuccess"));
                } else {
                    message.error(t("profile.sharedGeoDataError"));
                }
            })
            .catch(() => {
                message.error(t("profile.sharedGeoDataError"));
            });
    };

    useEffect(() => {
        refreshToken();

        axios
            .get("/data/utc-zones.json")
            .then((res) => {
                // Normalize zones to AntD Select option shape {label, value}
                setTimeZones(res.data.map((z) => ({ label: z.value, value: z.value })));
            })
            .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/profile/`).then((res) => {
            const ln = normalizeLang(res.languageGeneration)
            setGenLang(ln);
            setProfile(res);
            if (res.timeZone) {
                setCurrentTimeZone(res.timeZone);
            }
            if (res.position) {
                setPosition(res.position);
            }
            if (res.industry) {
                setIndustry(res.industry);
            }
            if (res.gender) {
                setGender(res.gender || "other");
            } else {
                setGender("other");
            }
        });

        try {
            fetchWrapper
                .get(`${baseUrl}/profile/facebook-pages`)
                .then((res) => {
                    if (res) {
                        if (res === "facebook_pages_not_found") {
                            navigate("?helpFbModal=true");
                            setFBModalInfoVisible(true);
                        } else {
                            setFbPages(res);
                        }
                    } else {
                        navigate("?helpFbModal=true");
                        setFBModalInfoVisible(true);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err === "facebook_pages_not_found") {
                        navigate("?helpFbModal=true");
                        setFBModalInfoVisible(true);
                    }
                });
        } catch (err) {
            console.error("facebook pages error:", err);
        }

        try {
            fetchWrapper
                .get(`${baseUrl}/profile/linkedin-pages`)
                .then((res) => {
                    if (res) {
                        setLinkedInPages(res);
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        } catch (err) {
            console.error("linkedin pages error:", err);
        }
    }, [handleUpdateProfile]);

    useEffect(() => {
        fetchWrapper.post(`${baseUrl}/profile/update-info`, {
            languageGeneration: genLang,
        });
        refreshToken();
    }, [genLang]);

    useEffect(() => {
        if (updateName) {
            fetchWrapper.post(`${baseUrl}/profile/update-info`, { name: updateName }).then(() => {
                refreshToken();
            });
        }
    }, [updateName]);

    useEffect(() => {
        if (updatePosition) {
            fetchWrapper.post(`${baseUrl}/profile/update-info`, { position: updatePosition }).then(() => {
                refreshToken();
            });
        }
    }, [updatePosition]);

    useEffect(() => {
        if (updateIndustry) {
            fetchWrapper.post(`${baseUrl}/profile/update-info`, { industry: updateIndustry }).then(() => {
                refreshToken();
            });
        }
    }, [updateIndustry]);

    useEffect(() => {
        if (!profile?.linkedinPageId && linkedInPages.length) {
            fetchWrapper
                .post(`${baseUrl}/profile/update-info`, {
                    linkedinPageId: linkedInPages[0]?.page_id,
                })
                .then((res) => {
                    if (res) {
                        sethandleUpdateProfile((p) => !p);
                    }
                });
        }
    }, [profile, linkedInPages]);


    const subscribeToNotifications = async () => {
        if (!isSupported || !user?.id) return;

        try {
            const registration = await navigator.serviceWorker.ready;
            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array("BAfb_HnTmARvuO8aNhbFb7z3EjL_0u8NmXym3j4PkTxRLQ0Q-YPMQx1j3iSmh6fXxpof7A2vzkr4Y_rt3P8M20A")
            });

            const response = await fetchWrapper.post(`${baseUrl}/push/subscribe`, {
                subscription: subscription, 
                userId: user.id,
                deviceType: 'web'
            });

            if (response.success) {
                console.log('✅ Подписка сохранена на бэкенде');
                message.success('Уведомления включены');
            } else {
                console.error('❌ Ошибка от бэкенда:', response.error);
                message.error('Ошибка сохранения подписки');
            }
        } catch (error) {
            console.error('❌ Ошибка подписки:', error);
            message.error('Ошибка включения уведомлений');
        }
    };
    
    const urlBase64ToUint8Array = (base64String) => {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    };

    const handleEnableNotifications = async () => {
        const granted = await requestPermission();
        if (granted && user?.id) {
            await subscribeToNotifications();
        }
    };

    console.log("user: ", user);
    console.log("organization: ", org);
    return (
        <Layout className="min-h-screen bg-gradient-to-b from-white to-violet-50">
            {/* Top bar */}
            <ImeanHeader initialDark={true}></ImeanHeader>
            <StickyNavigationHeader headerTitle={t("profile.header")} onBackClick={() => navigate("/home")}></StickyNavigationHeader>

            {/* Main content */}
            <Layout.Content className="max-w-6xl mx-auto w-full px-4 md:px-6 lg:px-8 py-6">
                <Row gutter={[16, 16]}>
                    {/* LEFT: Profile summary & preferences */}
                    <Col xs={24} lg={10}>
                        <Card
                            className="shadow-sm rounded-2xl"
                            bodyStyle={{ padding: 16 }}
                            title={<Space><Avatar shape="square" size={40}><span className="font-semibold">U</span></Avatar></Space>}
                            extra={subDateEnd ? <Tag color="green">Premium: {moment(subDateEnd).format("DD/MM/YYYY")}</Tag> : null}
                        >
                            {/* Profile Essentials */}
                            <Space direction="vertical" size={12} className="w-full">
                                {/* Brand / User row */}
                                <Row align="middle" justify="center" gutter={[12, 12]}>
                                    <Col>
                                        <Space size={10} align="center">
                                            <OrganizationLogo />
                                        </Space>
                                    </Col>
                                </Row>

                                {/* Inputs */}
                                <Form layout="vertical" className="profile-form">
                                    <Row gutter={[12, 12]}>
                                        <Col xs={24}>
                                            <Form.Item
                                                label={t("profile.name")}
                                                colon={false}
                                                className="!mb-2"
                                                extra={<Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {t("profile.nameHint") || "Shown on generated posts & signatures"}
                                                </Typography.Text>}
                                            >
                                                <Input
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    placeholder="Your full name"
                                                    size="middle"
                                                    allowClear
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24}>
                                            <Form.Item label={t("profile.login")} colon={false} className="!mb-2">
                                                {/* Friendlier email view: bigger text, copy button, no code styling */}
                                                <Space direction="vertical" size={2} className="w-full">
                                                    <Typography.Paragraph
                                                        copyable={{ text: user.email }}
                                                        className="!mb-0 break-all"
                                                        style={{ fontSize: 14 }}
                                                    >
                                                        {user.email}
                                                    </Typography.Paragraph>
                                                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                        {t("profile.readonly") || "read-only"}
                                                    </Typography.Text>
                                                </Space>
                                            </Form.Item>
                                        </Col>

                                        {org?.organization?.id && (
                                            <>
                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label={t("profile.position")}
                                                        colon={false}
                                                        className="!mb-2"
                                                    >
                                                        <Input
                                                            value={position}
                                                            onChange={(e) => setPosition(e.target.value)}
                                                            placeholder="Not set"
                                                            size="middle"
                                                            allowClear
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label={t("profile.industry")}
                                                        colon={false}
                                                        className="!mb-2"
                                                    >
                                                        <Input
                                                            value={industry}
                                                            onChange={(e) => setIndustry(e.target.value)}
                                                            placeholder="Not set"
                                                            size="middle"
                                                            allowClear
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </>
                                        )}

                                        <Col xs={24} md={12}>
                                            <Form.Item label={t("profile.gender")} colon={false} className="!mb-2">
                                                <Select
                                                    size="middle"
                                                    value={gender}
                                                    className="min-w-[160px]"
                                                    onChange={handleChangeGender}
                                                    options={[
                                                        { value: "male", label: "Male" },
                                                        { value: "female", label: "Female" },
                                                        { value: "other", label: "Other" },
                                                    ]}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={12}>
                                            <Form.Item label={t("profile.lang")} colon={false} className="!mb-2">
                                                <Select
                                                    size="middle"
                                                    value={genLang}
                                                    className="min-w-[160px]"
                                                    onChange={onChangeLanguage}
                                                    options={[
                                                        { value: "kk", label: "Қазақша" },
                                                        { value: "ru", label: "Русский" },
                                                        { value: "en", label: "English" },
                                                    ]}
                                                />
                                            </Form.Item>
                                        </Col>

                                        {!!timeZones.length && (
                                            <Col xs={24} md={24}>
                                                <Form.Item
                                                    label={<Space size={6} align="center"><GlobalOutlined />{t("profile.timeZone")}</Space>}
                                                    colon={false}
                                                    className="!mb-0"
                                                >
                                                    {/* Cleaner layout: select + help, hint below */}
                                                    <Space size={8} align="center">
                                                        <Select
                                                            value={currentTimeZone}
                                                            className="min-w-[240px]"
                                                            size="large"
                                                            showSearch
                                                            optionFilterProp="label"
                                                            onChange={onChangeTimeZone}
                                                            options={timeZones}
                                                            dropdownMatchSelectWidth={280}
                                                        />
                                                        <TimeZoneModal />
                                                    </Space>
                                                    <div className="mt-1">
                                                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                            {t("profile.timeZoneHint") || "Used for scheduling & deadlines"}
                                                        </Typography.Text>
                                                    </div>
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </Row>
                                </Form>

                                {/* Location banner */}
                                <Alert
                                    type="info"
                                    showIcon
                                    className="rounded-lg"
                                    message={
                                        <Space size={8} wrap>
                                            <span>{t("profile.shareLocationExplanation")}</span>
                                        </Space>
                                    }
                                    action={
                                        <Button size="middle" type="primary" onClick={shareGeoData}>
                                            {profile?.coordinates?.length ? t("profile.buttons.reshare") : t("profile.buttons.share")}
                                        </Button>
                                    }
                                />

                                <Card
                                    size="small"
                                    className="rounded-xl border border-gray-200 mt-4"
                                    bodyStyle={{ padding: 16 }}
                                >
                                    <Space direction="vertical" size={12} className="w-full">
                                        <Typography.Title level={5} style={{ margin: 0 }}>
                                            🔔 Уведомления браузера
                                        </Typography.Title>

                                        <Space direction="vertical" size={8} className="w-full">
                                            {!isSupported ? (
                                                <Alert
                                                    message="Браузер не поддерживает уведомления"
                                                    type="warning"
                                                    showIcon
                                                    className="rounded-lg"
                                                />
                                            ) : permission === 'denied' ? (
                                                <Alert
                                                    message="Разрешение заблокировано"
                                                    description="Разрешите уведомления в настройках браузера"
                                                    type="error"
                                                    showIcon
                                                    className="rounded-lg"
                                                />
                                            ) : canShow ? (
                                                <Alert
                                                    message="Уведомления включены"
                                                    type="success"
                                                    showIcon
                                                    className="rounded-lg"
                                                />
                                            ) : (
                                                <Alert
                                                    message="Разрешите уведомления"
                                                    description="Получайте важные уведомления даже когда приложение закрыто"
                                                    type="info"
                                                    showIcon
                                                    className="rounded-lg"
                                                />
                                            )}

                                            <Space size={8} wrap>
                                                {!canShow && permission !== 'denied' && (
                                                    <Button
                                                        type="primary"
                                                        size="middle"
                                                        onClick={handleEnableNotifications}
                                                        className="bg-blue-600 hover:bg-blue-700"
                                                    >
                                                        {permission === 'default' ? '🔔 Разрешить уведомления' : '🔄 Запросить снова'}
                                                    </Button>
                                                )}

                                                {canShow && (
                                                    <Button
                                                        size="middle"
                                                        onClick={() => {
                                                            showSuccess('Тестовое уведомление!', {
                                                                body: 'Это тестовое уведомление из вашего профиля',
                                                                onClick: () => console.log('Уведомление кликнуто!')
                                                            });
                                                            setTimeout(() => {
                                                                showInfo('Тест из фона', {
                                                                    body: 'Браузер свернут?'
                                                                });
                                                            }, 5000);
                                                        }}
                                                    >
                                                        📨 Тест уведомления
                                                    </Button>
                                                )}
                                                {canShow && (
                                                    <Button
                                                        size="middle"
                                                        onClick={() => showError('Что-то пошло не так!', {
                                                            body: 'Это пример уведомления об ошибке',
                                                            requireInteraction: true
                                                        })}
                                                    >
                                                        ⚠️ Тест ошибки
                                                    </Button>
                                                )}

                                                {/* <Card size="small" className="rounded-lg border border-gray-200">
                                                    <Space direction="vertical" size={12} className="w-full">
                                                        <Typography.Text strong>📱 Мобильные уведомления</Typography.Text>
                                                        <NotificationTester />

                                                        <Alert
                                                            message="Инструкция для мобильных"
                                                            description={
                                                                <Space direction="vertical" size={4}>
                                                                    <div><strong>Android (Chrome):</strong></div>
                                                                    <div>1. Нажми "Разрешить уведомления"</div>
                                                                    <div>2. В настройках сайта разреши уведомления</div>
                                                                    <div>3. Добавь сайт на домашний экран</div>

                                                                    <div style={{ marginTop: '8px' }}><strong>iOS (Safari):</strong></div>
                                                                    <div>1. Нажми "Поделиться"</div>
                                                                    <div>2. Выбери "На экран «Домой»"</div>
                                                                    <div>3. Открой через добавленный ярлык</div>
                                                                </Space>
                                                            }
                                                            type="info"
                                                        />
                                                    </Space>
                                                </Card> */}
                                            </Space>
                                        </Space>
                                    </Space>
                                </Card>
                            </Space>

                            <Divider className="!my-3" />

                            {/* Organization / Actions section */}
                            <Space direction="vertical" size={12} className="w-full">
                                {org?.organization?.id ? (
                                    <>
                                        <Typography.Title level={5} style={{ margin: 0 }}>
                                            {t("profile.organizationTitle")}
                                        </Typography.Title>
                                        <OrganizationSettings />
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            type="primary"
                                            size="middle"
                                            className="!bg-violet-600 hover:!bg-violet-500"
                                            onClick={() => navigate("/subscription-plans")}
                                            block
                                        >
                                            {t("profile.subscriptionManagement")}
                                        </Button>
                                        <InviteFriend handleUpdate={sethandleUpdateReferrals} />
                                        <ReferralsModal handleUpdate={handleUpdateReferrals} />
                                    </>
                                )}
                                <RemoveAccountModal handleUpdate={sethandleUpdateProfile} profile={profile} />
                            </Space>
                        </Card>
                    </Col>

                    {/* RIGHT: Social connections */}
                    <Col xs={24} lg={14}>
                        <Card className="shadow-sm rounded-2xl social-card" bodyStyle={{ padding: 16 }} title={t("profile.socialConnectionsTitle")}>
                            <Space direction="vertical" size={12} className="w-full">
                                {/* LinkedIn */}
                                <Card
                                    size="small"
                                    className="rounded-xl social-connection li-card border border-gray-100 hover:shadow-md transition-shadow"
                                    bodyStyle={{ padding: 12 }}
                                >
                                    {/* Header */}
                                    <Row align="middle" justify="space-between" gutter={[12, 12]}>
                                        <Col flex="auto">
                                            <Space size={10} align="center" className="min-w-0 w-full">
                                                <Avatar size={40} style={{ background: "#1677ff" }} icon={<LinkedinOutlined />} />
                                                <div className="min-w-0 w-full">
                                                    <Space size={8} align="center" wrap>
                                                        <Typography.Text strong>LinkedIn</Typography.Text>
                                                        {tokens.linkedIn ? (
                                                            <Tag color="green" className="!m-0">{t("profile.status.connected") || "Connected"}</Tag>
                                                        ) : (
                                                            <Tag color="default" className="!m-0">{t("profile.status.notConnected") || "Not linked"}</Tag>
                                                        )}
                                                    </Space>
                                                    <Typography.Text type="secondary" className="block break-words whitespace-normal">
                                                        {tokens.linkedIn
                                                            ? (socialMediaUsers?.linkedIn?.username?.toLowerCase().includes("couldnt fetch")
                                                                ? t("profile.status.linkedNoDetails") || "Account linked (details unavailable)"
                                                                : socialMediaUsers?.linkedIn?.username)
                                                            : t("profile.hintConnectLinkedIn")}
                                                    </Typography.Text>
                                                </div>
                                            </Space>
                                        </Col>

                                        <Col>
                                            {tokens.linkedIn && (
                                                <Button
                                                    size="middle"
                                                    icon={<SettingOutlined />}
                                                    onClick={() => setLinkedInModalVisible(true)}
                                                >
                                                    {t("profile.buttons.pages")}
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>

                                    <Divider className="!my-3" />

                                    {/* Footer: actions right-aligned */}
                                    <Row align="middle" justify="space-between" gutter={[8, 8]}>
                                        <Col flex="auto">
                                            {!tokens.linkedIn ? (
                                                <Typography.Text type="secondary" className="text-[12px]">
                                                    {t("profile.tip.linkBenefits") || "Schedule posts and access analytics after linking."}
                                                </Typography.Text>
                                            ) : (
                                                <Typography.Text type="secondary" className="text-[12px]">
                                                    {t("profile.tip.managePages") || "Manage connected Pages for publishing."}
                                                </Typography.Text>
                                            )}
                                        </Col>
                                        <Col>
                                            <Space size={8} wrap>
                                                {tokens.linkedIn ? (
                                                    <Button danger onClick={() => socialUnhook.linkedIn()}>
                                                        {t("profile.buttons.unlink")}
                                                    </Button>
                                                ) : (
                                                    <Button type="primary" onClick={() => socialLogin.linkedIn()}>
                                                        {t("profile.buttons.link")}
                                                    </Button>
                                                )}
                                            </Space>
                                        </Col>
                                    </Row>
                                </Card>

                                {/* Facebook */}
                                {process.env.REACT_APP_IS_HIDE_FACEBOOK !== "true" && (
                                    <Card
                                        size="small"
                                        className="rounded-xl social-connection fb-card border border-gray-100 hover:shadow-md transition-shadow"
                                        bodyStyle={{ padding: 12 }}
                                    >
                                        {/* Header */}
                                        <Row align="middle" justify="space-between" gutter={[12, 12]}>
                                            <Col flex="auto">
                                                <Space size={10} align="center" className="min-w-0 w-full">
                                                    <Avatar size={40} style={{ background: "#1877f2" }} icon={<FacebookOutlined />} />
                                                    <div className="min-w-0 w-full">
                                                        <Space size={8} align="center" wrap>
                                                            <Typography.Text strong>Facebook</Typography.Text>
                                                            {tokens.facebook ? (
                                                                <Tag color="green" className="!m-0">{t("profile.status.connected") || "Connected"}</Tag>
                                                            ) : (
                                                                <Tag color="default" className="!m-0">{t("profile.status.notConnected") || "Not linked"}</Tag>
                                                            )}
                                                        </Space>
                                                        <Typography.Text type="secondary" className="block break-words whitespace-normal">
                                                            {tokens.facebook
                                                                ? (socialMediaUsers?.facebook?.username?.toLowerCase().includes("couldnt fetch")
                                                                    ? t("profile.status.linkedNoDetails") || "Account linked (details unavailable)"
                                                                    : socialMediaUsers?.facebook?.username)
                                                                : t("profile.hintConnectFacebook")}
                                                        </Typography.Text>
                                                    </div>
                                                </Space>
                                            </Col>

                                            <Col>
                                                <Button
                                                    size="middle"
                                                    icon={<SettingOutlined />}
                                                    onClick={() => (tokens.facebook ? setFBModalVisible(true) : setFBModalInfoVisible(true))}
                                                >
                                                    {t("profile.buttons.pages")}
                                                </Button>
                                            </Col>
                                        </Row>

                                        <Divider className="!my-3" />

                                        {/* Footer */}
                                        <Row align="middle" justify="space-between" gutter={[8, 8]}>
                                            <Col flex="auto">
                                                {!tokens.facebook ? (
                                                    <Typography.Text type="secondary" className="text-[12px]">
                                                        {t("profile.tip.linkBenefits") || "Link Facebook to publish directly and view stats."}
                                                    </Typography.Text>
                                                ) : (
                                                    <Typography.Text type="secondary" className="text-[12px]">
                                                        {t("profile.tip.managePages") || "Manage connected Pages for publishing."}
                                                    </Typography.Text>
                                                )}
                                            </Col>
                                            <Col>
                                                <Space size={8} wrap>
                                                    {tokens.facebook ? (
                                                        <Button danger onClick={() => socialUnhook.facebook()}>
                                                            {t("profile.buttons.unlink")}
                                                        </Button>
                                                    ) : (
                                                        <Button type="primary" onClick={() => socialLogin.facebook()}>
                                                            {t("profile.buttons.link")}
                                                        </Button>
                                                    )}
                                                </Space>
                                            </Col>
                                        </Row>
                                    </Card>
                                )}

                                {/* Instagram */}
                                <Card
                                    size="small"
                                    className="rounded-xl social-connection ig-card border border-gray-100 hover:shadow-md transition-shadow"
                                    bodyStyle={{ padding: 12 }}
                                >
                                    {/* Header */}
                                    <Row align="middle" justify="space-between" gutter={[12, 12]}>
                                        <Col flex="auto">
                                            <Space size={10} align="center" className="min-w-0 w-full">
                                                <Avatar
                                                    size={40}
                                                    style={{
                                                        background: "linear-gradient(135deg,#f58529,#feda77,#dd2a7b,#8134af,#515bd4)",
                                                    }}
                                                    icon={<InstagramOutlined />}
                                                />
                                                <div className="min-w-0 w-full">
                                                    <Space size={8} align="center" wrap>
                                                        <Typography.Text strong>Instagram</Typography.Text>
                                                        {tokens.instagram ? (
                                                            <Tag color="green" className="!m-0">
                                                                {t("profile.status.connected") || "Connected"}
                                                            </Tag>
                                                        ) : (
                                                            <Tag color="default" className="!m-0">
                                                                {t("profile.status.notConnected") || "Not linked"}
                                                            </Tag>
                                                        )}
                                                    </Space>
                                                    <Typography.Text type="secondary" className="block break-words whitespace-normal">
                                                        {tokens.instagram
                                                            ? (socialMediaUsers?.instagram?.username
                                                                ?.toLowerCase()
                                                                ?.includes("couldnt fetch")
                                                                ? t("profile.status.linkedNoDetails") ||
                                                                "Account linked (details unavailable)"
                                                                : socialMediaUsers?.instagram?.username)
                                                            : t("profile.hintConnectInstagram")}
                                                    </Typography.Text>
                                                </div>
                                            </Space>
                                        </Col>

                                        <Col>
                                            {!tokens.instagram && (
                                                <Button size="middle" onClick={() => setInstModalInfoVisible(true)}>
                                                    {t("profile.buttons.help")}
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>

                                    <Divider className="!my-3" />

                                    {/* Footer */}
                                    <Row align="middle" justify="space-between" gutter={[8, 8]}>
                                        <Col flex="auto">
                                            {!tokens.instagram ? (
                                                <Typography.Text type="secondary" className="text-[12px]">
                                                    {t("profile.tip.linkBenefits") ||
                                                        "Link Instagram to schedule posts and track engagement."}
                                                </Typography.Text>
                                            ) : (
                                                <Typography.Text type="secondary" className="text-[12px]">
                                                    {t("profile.tip.managePages") || "Manage your connected account."}
                                                </Typography.Text>
                                            )}
                                        </Col>
                                        <Col>
                                            <Space size={8} wrap>
                                                {tokens.instagram ? (
                                                    <Button danger onClick={() => socialUnhook.instagram()}>
                                                        {t("profile.buttons.unlink")}
                                                    </Button>
                                                ) : (
                                                    <Button type="primary" onClick={() => socialLogin.instagram()}>
                                                        {t("profile.buttons.link")}
                                                    </Button>
                                                )}
                                            </Space>
                                        </Col>
                                    </Row>
                                </Card>

                                {/* Threads */}
                                <Card
                                    size="small"
                                    className="rounded-xl social-connection threads-card border border-gray-100 hover:shadow-md transition-shadow"
                                    bodyStyle={{ padding: 12 }}
                                >
                                    {/* Header */}
                                    <Row align="middle" justify="space-between" gutter={[12, 12]}>
                                        <Col flex="auto">
                                            <Space size={10} align="center" className="min-w-0 w-full">
                                                <Avatar size={40} src={threadsIcon}>
                                                    T
                                                </Avatar>
                                                <div className="min-w-0 w-full">
                                                    <Space size={8} align="center" wrap>
                                                        <Typography.Text strong>Threads</Typography.Text>
                                                        {tokens.threads ? (
                                                            <Tag color="green" className="!m-0">
                                                                {t("profile.status.connected") || "Connected"}
                                                            </Tag>
                                                        ) : (
                                                            <Tag color="default" className="!m-0">
                                                                {t("profile.status.notConnected") || "Not linked"}
                                                            </Tag>
                                                        )}
                                                    </Space>
                                                    <Typography.Text type="secondary" className="block break-words whitespace-normal">
                                                        {tokens.threads
                                                            ? (socialMediaUsers?.threads?.username?.toLowerCase?.()?.includes("couldnt fetch")
                                                                ? t("profile.status.linkedNoDetails") || "Account linked (details unavailable)"
                                                                : socialMediaUsers?.threads?.username)
                                                            : (t("profile.hintConnectThreads") || "Link Threads to schedule posts and track insights.")}
                                                    </Typography.Text>
                                                </div>
                                            </Space>
                                        </Col>

                                    </Row>

                                    <Divider className="!my-3" />

                                    {/* Footer */}
                                    <Row align="middle" justify="space-between" gutter={[8, 8]}>
                                        <Col flex="auto">
                                            <Typography.Text type="secondary" className="text-[12px]">
                                                {tokens.threads
                                                    ? (t("profile.tip.managePages") || "Manage your connected account.")
                                                    : (t("profile.tip.linkBenefits") || "Link to publish directly and view stats.")}
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Space size={8} wrap>
                                                {tokens.threads ? (
                                                    <Button danger onClick={() => socialUnhook.threads()}>
                                                        {t("profile.buttons.unlink")}
                                                    </Button>
                                                ) : (
                                                    <Button type="primary" onClick={() => socialLogin.threads()}>
                                                        {t("profile.buttons.link")}
                                                    </Button>
                                                )}
                                            </Space>
                                        </Col>
                                    </Row>
                                </Card>
                            </Space>
                        </Card>

                        {/* Modals (keep your existing logic) */}
                        {tokens.linkedIn && (
                            <Modal
                                open={linkedInModalVisible}
                                title="Select LinkedIn Page"
                                onCancel={() => setLinkedInModalVisible(false)}
                                footer={null}
                            >
                                <div className="flex flex-col gap-2 pt-2">
                                    {linkedInPages?.length ? (
                                        linkedInPages.map((page, i) => (
                                            <Button
                                                key={i}
                                                block
                                                size="middle"
                                                type={page?.page_id === profile?.linkedinPageId ? "primary" : "default"}
                                                onClick={() =>
                                                    page?.page_id === profile?.linkedinPageId
                                                        ? setLinkedInModalVisible(false)
                                                        : handleChangeLinkedInPage(page)
                                                }
                                            >
                                                {page?.name}
                                            </Button>
                                        ))
                                    ) : (
                                        <div className="text-center my-8">
                                            <Typography.Text>{t("profile.noPagesLinkedIn")}</Typography.Text>
                                            <div className="mt-3">
                                                <Button size="middle" type="link" onClick={() => navigate("/guideline")}>Open Setup Guide</Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Modal>
                        )}

                        <Modal
                            open={fbModalVisible}
                            title="Select Facebook Page"
                            onCancel={() => setFBModalVisible(false)}
                            footer={null}
                        >
                            <div className="flex flex-col gap-2 pt-2">
                                {fbPages?.length ? (
                                    fbPages.map((page, i) => (
                                        <Button
                                            key={i}
                                            block
                                            size="middle"
                                            type={page?.id === profile?.facebookPageId ? "primary" : "default"}
                                            onClick={() =>
                                                page?.id === profile?.facebookPageId ? setFBModalVisible(false) : handleChangeFBPage(page)
                                            }
                                        >
                                            {page?.name}
                                        </Button>
                                    ))
                                ) : (
                                    <div className="text-center my-8">
                                        <Typography.Text>{t("profile.noPagesFB")}</Typography.Text>
                                        <div className="mt-3">
                                            <Button size="middle" type="link" onClick={() => navigate("/guideline")}>Open Setup Guide</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Modal>

                        <Modal
                            open={fbModalInfoVisible}
                            title="Facebook Help"
                            onCancel={() => {
                                setFBModalInfoVisible(false);
                                setSearchParams({});
                            }}
                            footer={null}
                        >
                            <Space direction="vertical" className="w-full">
                                <Typography.Paragraph>
                                    {t("profile.hintFacebookHelp")}
                                </Typography.Paragraph>
                                <Button size="middle" type="link" onClick={() => navigate("/guideline")}>Open Setup Guide</Button>
                            </Space>
                        </Modal>

                        {!tokens.instagram && (
                            <Modal
                                open={instModalInfoVisible}
                                title="Instagram Help"
                                onCancel={() => setInstModalInfoVisible(false)}
                                footer={null}
                            >
                                <Space direction="vertical" className="w-full">
                                    <Typography.Paragraph>
                                        {t("profile.hintInstagramHelp")}
                                    </Typography.Paragraph>
                                    <Button size="middle" type="link" onClick={() => navigate("/guideline")}>Open Setup Guide</Button>
                                </Space>
                            </Modal>
                        )}
                    </Col>
                </Row>
            </Layout.Content>
        </Layout>
    );

};
